export const mockStudentRegisterFields = [
  {
    name: "firstName",
    type: "text",
    label: "First Name",
    gridColumn: "span 2",
  },
  { name: "lastName", type: "text", label: "Last Name", gridColumn: "span 2" },
  { name: "email", type: "email", label: "Email", gridColumn: "span 4" },
  { name: "password", type: "password", label: "Password", gridColumn: "span 4" },
  {
    name: "phoneNumber",
    type: "text",
    label: "Phone Number",
    gridColumn: "span 2",
  },
  { name: "age", type: "number", label: "Age", gridColumn: "span 2" },
  { name: "cnic", type: "number", label: "CNIC", gridColumn: "span 4" },
  {
    name: "department",
    type: "select",
    label: "Department",
    gridColumn: "span 2",
    options: [
      { value: "BSCS", label: "BSCS" },
      { value: "BSSE", label: "BSSE" },
      { value: "BSIT", label: "BSIT" },
      { value: "LAW", label: "LAW" },
      { value: "English", label: "English" },
      { value: "Urdu", label: "Urdu" },
      { value: "Sports", label: "Sports" },
    ],
  },
  {
    name: "section",
    type: "select",
    label: "Section",
    gridColumn: "span 2",
    options: [
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "C", label: "C" },
      { value: "D", label: "D" },
      { value: "E", label: "E" },
    ],
  },
  {
    name: "profilePicture",
    type: "file",
    label: "Profile Picture",
    gridColumn: "span 4",
  },
];

export const mockStudentLoginFields = [
  { name: "email", type: "email", label: "Email", gridColumn: "span 4" },
  {
    name: "password",
    type: "password",
    label: "Password",
    gridColumn: "span 4",
  },
];
